import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from 'react';
import TransLoco from 'shared/components/trans-loco';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import { Hint } from '@systemeio/ui';
import { useCalendars } from 'modules/profile/integrations/google/hooks/use-calendars';
import useUser from 'shared/hooks/use-user';
import { hasWorkspaces } from 'shared/hooks/use-user/utils/has-workspaces';
export interface HotsEmailAddressProps {
  googleIntegrationId: string | undefined;
}
export const HostEmailAddress = t0 => {
  const $ = _c(17);
  const {
    googleIntegrationId
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    user,
    isWorkspaceOwner
  } = useUser();
  const [hostEmailAddress, setHostEmailAddress] = useState("");
  const {
    data: calendars
  } = useCalendars();
  let t1;
  let t2;
  if ($[0] !== calendars || $[1] !== googleIntegrationId || $[2] !== isWorkspaceOwner || $[3] !== user) {
    t1 = () => {
      if (!user) {
        return;
      }
      if (calendars) {
        if (googleIntegrationId) {
          const calendar = calendars.find(item => item.integration.id === googleIntegrationId);
          if (calendar) {
            setHostEmailAddress(calendar.integration.googleUserEmail);
            return;
          }
        }
      }
      if (!isWorkspaceOwner && hasWorkspaces(user)) {
        const membership = user.workspaceMemberships.find(ws => ws.ownerId === user.workspaceOwner);
        if (membership) {
          setHostEmailAddress(membership.workspaceOwner.email);
          return;
        }
      }
      if (user.mainUser) {
        setHostEmailAddress(user.mainUser.user.email);
      }
    };
    t2 = [user, isWorkspaceOwner, calendars, googleIntegrationId];
    $[0] = calendars;
    $[1] = googleIntegrationId;
    $[2] = isWorkspaceOwner;
    $[3] = user;
    $[4] = t1;
    $[5] = t2;
  } else {
    t1 = $[4];
    t2 = $[5];
  }
  useEffect(t1, t2);
  let t3;
  if ($[6] !== t) {
    t3 = t("dashboard.calendar.host_email_address_hint");
    $[6] = t;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== hostEmailAddress) {
    t4 = {
      email: hostEmailAddress
    };
    $[8] = hostEmailAddress;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      b: <b />
    };
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t || $[12] !== t4) {
    t6 = <TransLoco t={t} i18nKey="dashboard.calendar.host_email_address" values={t4} components={t5} />;
    $[11] = t;
    $[12] = t4;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t6) {
    t7 = <Hint label={t3}>{t6}</Hint>;
    $[14] = t3;
    $[15] = t6;
    $[16] = t7;
  } else {
    t7 = $[16];
  }
  return t7;
};